var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1690_42640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4396 17.7493L14.0301 4.80026C13.9256 4.70002 13.7865 4.64404 13.6417 4.64404C13.4969 4.64404 13.3577 4.70002 13.2532 4.80026L0.843686 17.7493C0.744827 17.8502 0.689453 17.9858 0.689453 18.127C0.689453 18.2682 0.744827 18.4038 0.843686 18.5047L4.08095 21.7419C4.18388 21.8452 4.3236 21.9034 4.46942 21.9038C4.54249 21.9028 4.6146 21.887 4.68138 21.8573C4.74815 21.8277 4.80821 21.7847 4.85789 21.7311L13.6417 12.4402L22.4254 21.7419C22.4751 21.7955 22.5352 21.8384 22.6019 21.8681C22.6687 21.8978 22.7408 21.9136 22.8139 21.9146C22.9562 21.9126 23.092 21.8544 23.1916 21.7527L26.4288 18.5155C26.4801 18.466 26.5211 18.4069 26.5494 18.3415C26.5778 18.2762 26.5929 18.2059 26.5939 18.1346C26.5949 18.0634 26.5817 17.9927 26.5553 17.9265C26.5288 17.8604 26.4895 17.8002 26.4396 17.7493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1690_42640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8981,
    height: 25.8981,
    fill: "white",
    transform: "translate(0.692993 0.323242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloUpArrow);
export default __webpack_public_path__ + "static/media/hilo-up-arrow.33ed99e86cc2aa9dfd50835e9b43e98a.svg";
export { ForwardRef as ReactComponent };